<template>
  <!-- 
  1.화면ID      : MCF_SC_003
  2.화면명      : 영업기회 Quota 조회/수정
  3.작성자      : 김찬종 차장
  4.화면설명    : 회계년도별 영업대표의 목표금액을 조회한다.
  5.Descrition : 2024.04.22 최초작성
  * A Copyright Notice : Copyright 2024 SNC.CO All rights reserved
  -->
  
  <div class="content-wrap">
    <div class="row">
      <!-- 검색 영역 시작 -->
      <div class="search-wrap">
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="회계년도">
                <template #end>
                  <ElSelect v-model="state.searchParams.fiscal_year" :options="state.yearList" @selectClick="( _, event) => onChange(event)" />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <ElLabel name="영업대표">
              <template #end>
                <ElSelect v-model="state.searchParams.sales_ceo" :options="state.ceoList" @selectClick="( _, event) => onChange(event)" />
              </template>
            </ElLabel>
          </div>
        </div>
      </div>
      <!-- 검색 영역 종료 -->
      <div class="search-detail-wrap"></div>
      <div class="text-end py-2">
        <ElButton type="excelDownload" @buttonClick="excelDownload()">엑셀다운</ElButton>
        <ElButton type="search" @buttonClick="doUpload()" style="padding:0.2rem 1.8rem !important">일괄등록</ElButton>
        <ElButton type="search" @buttonClick="onSearch()">검색</ElButton>
      </div>
      <!-- 그리드 영역 시작 -->
      <div class="table-responsive table-list">
        <DataTable 
          ref="quotaTable"
          :value="state.gridRowData"
          :rowClass="rowClass"
          rowGroupMode="rowspan"
          groupRowsBy="group_nm"
          editMode="cell" 
          @cell-edit-complete="onCellEditComplete"
          scrollable scrollHeight="600px"
        >

            <template #header>
              <div class="text-end">
                <span>( 단위 : 원 )</span>
              </div>
            </template>
            <Column field="group_nm" header="분류" footer="Total" style="min-width:3rem;"></Column>
            <Column field="class_nm" header="Product" style="min-width:4rem"></Column>
            <Column field="qty_sum" header="Quota All" v-model:footer="state.total.all" style="min-width:8rem; text-align:right;">
                <template #body="{ data, field }">
                    {{ formatCurrency(data[field]) }}
                </template>
            </Column>
            <Column field="prod_ratio" header="Ratio" style="min-width:3rem; text-align:right;">
              <template #body="{ data, field }">
                    {{ formatPercent(data[field]) }}
                </template>
            </Column>
            <Column field="sales_ceo_nm" header="영업대표" style="min-width:3rem; text-align:right;" hidden>
              <template #body="{ data, field }">
                {{data[field] }}
              </template>
            </Column>
            <Column field="qty1" header="Q1" v-model:footer="state.total.qty1" style="width:7rem; text-align:right;">
                <template #body="{ data, field }">
                    {{ formatCurrency(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <!-- <InputNumber v-model="data[field]" inputClass="quota-control" autofocus /> -->
                    <ElInput
                      onlyNumber
                      :modelValue="data[field]"
                      @update:modelValue="r=>data[field]=r"
                    />
                </template>
            </Column>
            <Column field="qty2" header="Q2" v-model:footer="state.total.qty2" style="width:7rem; text-align:right;">
                <template #body="{ data, field }">
                    {{ formatCurrency(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <!-- <InputNumber v-model="data[field]" inputClass="quota-control" autofocus /> -->
                    <ElInput
                      onlyNumber
                      :modelValue="data[field]"
                      @update:modelValue="r=>data[field]=r"
                    />
                </template>
            </Column>
            <Column field="qty3" header="Q3" v-model:footer="state.total.qty3" style="width:7rem; text-align:right;">
                <template #body="{ data, field }">
                    {{ formatCurrency(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <!-- <InputNumber v-model="data[field]" inputClass="quota-control" autofocus /> -->
                    <ElInput
                      onlyNumber
                      :modelValue="data[field]"
                      @update:modelValue="r=>data[field]=r"
                    />
                </template>
            </Column>
            <Column field="qty4" header="Q4" v-model:footer="state.total.qty4" style="width:7rem; text-align:right;">
                <template #body="{ data, field }">
                    {{ formatCurrency(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <!-- <InputNumber v-model="data[field]" inputClass="quota-control" autofocus /> -->
                    <ElInput
                      onlyNumber
                      :modelValue="data[field]"
                      @update:modelValue="r=>data[field]=r"
                    />
                </template>
            </Column>
        </DataTable>
      </div>
      <!-- 그리드 영역 종료 -->
      <div class="text-end py-2">

      </div>
    </div>
  </div>
  <!-- 콘텐츠 영역 종료 -->
  <ExcelManage v-show="false" ref="excelManage" />
</template>
     
<script setup>   
import {reactive,ref,onMounted} from 'vue';
import vueRouterCmn   from '@/js/vueRouterCmn';
import ExcelManage    from '@/components/common/MCO_EX_001.vue';
import DataTable      from 'primevue/datatable';
import Column         from 'primevue/column';
import { useUserStore } from '@/store/user';
import { useCodeStore } from '@/store/code'
const codeStore = useCodeStore()
const userStore = useUserStore()
const excelManage = ref();
const quotaTable = ref();

import { useLoading } from '@/composable/Loading.js'
const { setIsLoading } = useLoading()
import { getLoadUsers } from '@/api/monthly';
import { quotaEdit, quotaSelect } from '@/api/quota';


  


onMounted(async () => {

    getYearList();
      await getSalesCeo();
    await onSearch();
});

//변수 선언 영역 
const state = reactive({
  gridRowData :[],
  searchParams : {
      fiscal_year   : '',
      sales_ceo   : ''
  },
  resultParams : {
      fiscal_year   : '',
      sales_ceo   : userStore.user.userNm ? userStore.user.userNm : '',               //영업대표
  },
  total : {
      qty1 : 0,
      qty2 : 0,
      qty3 : 0,
      qty4 : 0,
      all  : 0
  },
  yearList : [],
  ceoList : []
});

/* 회계년도 목록 */
const getYearList = () => {
  let year = 2023; //시작년도
  const thisYear = new Date().getFullYear();
  const nextYear = thisYear + 2;

  state.yearList = [];
  while(year <= nextYear) {
    state.yearList.push({text: year+'년', value: year});
    year++;
  }

  state.searchParams.fiscal_year = thisYear;
};

/* 영업대표 목록 */
const getSalesCeo = async () => {
  try {
    setIsLoading(true)

    const res = await getLoadUsers({employee_id : userStore.user.employeeId,auth_grp_id : userStore.user.authGrpId})

    if(['ADMIN', 'E'].includes(userStore.user.authGrpId))  state.ceoList.push({ text: '전체', value: '' })

    //사용자 목록을 영업대표{text, value} 목록으로 변환
    res.rtn.forEach(user => {
      state.ceoList.push({ text: user.user_nm, value: user.employee_id })
    });
    
    //영업대표 목록 초기화
    state.searchParams.sales_ceo = state.ceoList[0].value;
  } catch (err) {
    console.error(err);
    alert("영업대표 초기화 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }

};

/* 양의 정수 체크 */
const isPositiveInteger = (val) => {
  let str = String(val);

  str = str.trim();

  if (!str) {
    return false;
  }

  str = str.replace(/^0+/, '') || '0';
  var n = Math.floor(Number(str));

  return n !== Infinity && String(n) === str && n >= 0;
};

/* row 스타일 적용 */
const rowClass = (data) => {
  return [{ 'bg-quota-subtle': data.lvl === '1' }]; //소계
};

/* 통화 양식 적용 */
const formatCurrency = (value) => {
  return new Intl.NumberFormat('ko-KR').format(value);
}

/* 비율 양식 적용 */
const formatPercent = (value) => {
  var option = {
    style: 'percent',
    minimumFractionDigits: 1
  };
  return new Intl.NumberFormat('ko-KR', option).format(value);
}

const doUpload = () => {
  vueRouterCmn.routerPush('MCF_SC_005', {fiscal_year : state.searchParams.fiscal_year})
}

/* 저장 */
const doSave = async () => {
  const isValid = validate();
  if(!isValid) {
    return;
  }

  const isConfirmed = confirm(`저장하시겠습니까?`);
  if(isConfirmed) {
    let params = {
      quotaVOList : state.gridRowData,
      fiscal_year : state.resultParams.fiscal_year,
      sales_ceo   : state.resultParams.sales_ceo
    }

    try {
      setIsLoading(true)
      const res = await quotaEdit(params)
      alert(`저장되었습니다.`);

      //검색조건 지정
      state.searchParams.fiscal_year = state.resultParams.fiscal_year;
      state.searchParams.sales_ceo = state.resultParams.sales_ceo;
      onSearch();
    } catch (err) {
      console.error(err)
      alert("에러가 발생하였습니다.");
    } finally {
      setIsLoading(false)
    }
  }
}

/** 입력값 유효성 체크 */
const validate = () => {
  let msg = codeStore.getCodeMsg('77777'); // 해당 항목은 필수 입력값입니다.

  if(state.resultParams.fiscal_year == '') {
    alert(msg)
    return false;
  } else if(state.resultParams.sales_ceo == '') {
    alert(msg)
    return false;
  } else if(state.resultParams.sales_ceo == 'All') {
    alert('영업대표가 전체인 경우는 저장할 수 없습니다.')
    return false;
  }

  return true;
}

/* 엑셀다운 */
const excelDownload = () => {
  const columns = quotaTable.value.columns.map(column => column.props);

  let fileNm = '영업기회 Quota'
  let header = columns
  let dataList = state.gridRowData

  excelManage.value.excelDownload(fileNm, header, dataList)
}

/* 검색조건 변경 */
const onChange = (event) => {
  onSearch();
};

/* 검색 */
const onSearch = async () => {
  try {
    setIsLoading(true)
    const res = await quotaSelect(state.searchParams)
    state.gridRowData = [...res.rtn].filter((item)=>{
      if(item.lvl === '3' || item.lvl === '1'){
        return item
      }
    })

    let ceoNm = ''
    state.ceoList.forEach((ceo)=>{
      if(ceo.value === state.searchParams.sales_ceo){
        ceoNm = ceo.text
      }
    })

    for(let item of state.gridRowData){
      Object.keys(item).filter((key)=>{
        if(key === 'qty1' || key === 'qty2' || key === 'qty3' || key === 'qty4') return true
      }).forEach((keyNm)=>{
        let event = {data : item,newValue : item[keyNm],field:keyNm}
        onCellEditComplete(event)
      })

      item.sales_ceo_nm = ceoNm
    }


    //검색조건 저장
    state.resultParams.fiscal_year = state.searchParams.fiscal_year;
    state.resultParams.sales_ceo = state.searchParams.sales_ceo;
    
    //Total 항목 reset
    resetTotal();
  } catch (err) {
    console.error(err)
    alert("전송 중 에러가 발생하였습니다.");
  } finally {
    setIsLoading(false)
  }
};

/* 셀 편집 */
const onCellEditComplete = (event) => {
  let { data, newValue, field } = event;

  switch(field) {
    case 'qty1':
    case 'qty2':
    case 'qty3':
    case 'qty4':
        if(isPositiveInteger(newValue)) {
            data[field] = newValue;

            // 해당 상품의 Quota All reset
            data.qty_sum = Number(data.qty1) + Number(data.qty2) + Number(data.qty3) + Number(data.qty4);
        } else {
            event.preventDefault();
        }
        break;
  }

  // 해당 분류의 소계 및 비율 reset
  resetSubTotal(data, field);
};


/********** 합계 및 비율 **********/
/* Total 항목 reset */
const resetTotal = () => {
  //전체 분류의 비율
  if(state.resultParams.sales_ceo === 'All') {
    calcSubRatioAll();
  }

  //Total 항목
  calcTotal();
}

/* SubTotal 항목 reset */
const resetSubTotal = (data, field) => {
  //해당 분류의 데이터
  const gropRowData = state.gridRowData.filter(row => row.group_id === data.group_id);

  //해당 분류의 소계
  if(data.group_cnt !== '1') { // 자식(상품)이 존재하는 경우만 소계 reset
    calcSubTotal(gropRowData, field);
  }

  //해당 분류의 비율
  calcSubRatio(gropRowData);

  //Total 항목
  calcTotal();
}

/* 해당 분류의 소계 */
const calcSubTotal = (gropRowData, field) => {
  const subTotalRow = gropRowData.filter(row => row.lvl === '1')[0]; //분류 row (소계)
  const productRows = gropRowData.filter(row => row.lvl !== '1');    //상품 rows

  //해당 분기(Q1, Q2, Q3, Q4) 소계
  const subTotal = productRows.reduce((prevTotal, currRow) => {
    const total = Number(prevTotal) + Number(currRow[field]);
    return total;
  }, 0);

  subTotalRow[field] = subTotal;

  // Quota All 계산
  subTotalRow.qty_sum = Number(subTotalRow.qty1) + Number(subTotalRow.qty2) + Number(subTotalRow.qty3) + Number(subTotalRow.qty4);
}

/* 해당 분류의 비율 */
const calcSubRatio = (gropRowData) => {
  const subTotalRow = gropRowData.filter(row => row.lvl === '1')[0];

  gropRowData.forEach(row => {
    const ratio = (Number(row.qty_sum) / Number(subTotalRow.qty_sum));
    row.prod_ratio = isNaN(ratio) ? 0 : ratio;
  });
}

/* 전체 분류의 비율 */
const calcSubRatioAll = () => {
  //중복 제거한 group_id
  let groupIds = state.gridRowData.map(row => row.group_id);
  let groupIdSet = new Set(groupIds);
  groupIds = [...groupIdSet];

  // 분류별로 비율 계산
  for(let groupId of groupIds) {
    const gropRowData = state.gridRowData.filter(row => row.group_id === groupId);
    calcSubRatio(gropRowData);
  }
}

/* Total 항목 */
const calcTotal = () => {
  const subTotalRows = state.gridRowData.filter(row => row.lvl === '1');

  let qty1 = 0, qty2 = 0, qty3 = 0, qty4 = 0, all = 0;
  subTotalRows.forEach(row => {
    qty1 += Number(row.qty1);
    qty2 += Number(row.qty2);
    qty3 += Number(row.qty3);
    qty4 += Number(row.qty4);
    all += Number(row.qty_sum);
  });

  state.total.qty1 = formatCurrency(qty1);
  state.total.qty2 = formatCurrency(qty2);
  state.total.qty3 = formatCurrency(qty3);
  state.total.qty4 = formatCurrency(qty4);
  state.total.all = formatCurrency(all);
}
</script>
